import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const ImportTransactionFilesRoutes: Routes = [
  {
    path: "import-transaction-files",
    loadComponent: () =>
      import("./import-transaction-files/import-transaction-files.component").then(
        (m) => m.ImportTransactionFilesComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./import-transaction-files-form/import-transaction-files-form.component").then(
            (m) => m.ImportTransactionFilesFormComponent,
          ),
      },
    ],
  },
];
